import * as PropTypes from "prop-types";
import styled from "styled-components";

export default function RadioButton({ id, name, defaultChecked, onChange }) {
  return (
    <Wrapper id={id}>
      <StyledRadioButton
        type="radio"
        name={name}
        defaultChecked={defaultChecked}
        onChange={onChange}
      />
      <CheckMark className="checkmark" />
    </Wrapper>
  );
}

const Wrapper = styled.label`
  display: inline-block;

  position: relative;
  padding-left: 20px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  &:hover input ~ .checkmark {
    background-color: ${({ theme }) => theme.green};
  }

  &:checked ~ .checkmark:after {
    display: block;
  }

  .checkmark &:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;

const StyledRadioButton = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;

  &:checked ~ .checkmark {
    background-color: ${({ theme }) => theme.green};
  }

  &:checked ~ .checkmark:after {
    display: block;
  }
`;

const CheckMark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: #fff;
  border-radius: 4px;

  &:after {
    content: "";
    position: absolute;
    display: none;

    left: 5px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;

RadioButton.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  defaultChecked: PropTypes.bool,
  onChange: PropTypes.func,
};
